/**
 * Modal component for adding new topics
 */

import React from 'react'
import { Modal, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const AddTopicModal = ({ visible, onOk, onCancel, value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={t('v3:ai_add_new_topic')}
      visible={visible}
      onOk={onOk}
      okText={t('v3:add_topic')}
      onCancel={onCancel}
      cancelText={t('v4:cancel')}
      centered
      className="add-new-topic-open"
    >
      <Input
        placeholder={t('v3:ai_add_new_topic')}
        size="large"
        value={value}
        onChange={onChange}
      />
    </Modal>
  )
}

export default AddTopicModal
